<h2 mat-dialog-title class="titulo">{{ data.titulo }}</h2>

<mat-dialog-content>
  <p class="bajada">
    Estos depósitos quedaron retenidos mientras no estaba aprobado. Puedes asignarlos ahora a
    <strong>{{ data.destino }}</strong>; se acreditan por la cola en unos segundos. Los que no
    asignes siguen en "Transacciones sin asignar".
  </p>

  <div class="tabla">
    <div class="fila encabezado">
      <span></span>
      <span>Fecha</span>
      <span>Origen</span>
      <span>Referencia</span>
      <span class="monto">Monto</span>
    </div>
    <div class="fila" *ngFor="let fila of filas" [class.hecha]="fila.estado === 'asignado'">
      <mat-checkbox
        [(ngModel)]="fila.elegido"
        [disabled]="asignando || fila.estado === 'asignado'"
        [attr.aria-label]="'Asignar la cartola ' + fila.deposito.cartolaId"
      ></mat-checkbox>
      <span>{{ fila.deposito.fechaRecepcion || '—' }} {{ fila.deposito.hora }}</span>
      <span class="origen">{{ fila.deposito.nombreOrigen || '—' }}</span>
      <span class="ref">{{ fila.deposito.codigoTransferencia }}</span>
      <span class="monto">{{ clp(fila.deposito.moSaldoAbono) }}</span>
      <span class="estado" *ngIf="fila.estado !== 'pendiente'" [ngClass]="fila.estado">
        <ng-container [ngSwitch]="fila.estado">
          <ng-container *ngSwitchCase="'enviando'">Asignando…</ng-container>
          <ng-container *ngSwitchCase="'asignado'">✓ Asignado</ng-container>
          <ng-container *ngSwitchCase="'error'">{{ fila.error }}</ng-container>
        </ng-container>
      </span>
    </div>
  </div>

  <p class="resumen" *ngIf="terminado">
    {{ asignados }} asignado(s){{ fallidos ? ' · ' + fallidos + ' con error: revísalos en "Transacciones sin asignar".' : '.' }}
  </p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cerrar()" [disabled]="asignando">
    {{ terminado ? 'Cerrar' : 'Ahora no' }}
  </button>
  <button
    mat-flat-button
    color="primary"
    type="button"
    *ngIf="elegidos.length"
    [disabled]="asignando"
    (click)="asignar()"
  >
    Asignar {{ elegidos.length }} ({{ clp(montoElegido) }})
  </button>
</mat-dialog-actions>
